var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showEmoji)?_c('i',{class:_vm.className},[_vm._v(_vm._s(_vm.iconContent))]):(_vm.showIcon)?_c('fluent-icon',{staticClass:"flex-shrink-0",class:_vm.className,attrs:{"size":_vm.iconSize,"icon":_vm.icon,"type":_vm.iconType || undefined}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }